module.exports = __webpack_public_path__ + "static/media/Personal_Date.1e920a71.pdf";